<mat-card class="my-5 unocod">
  <mat-card-header>
    <i class="fas fa-user-ninja uicon mx-2"></i>
    <mat-card-title>Χρήστες χωρίς Αντικαταβολές</mat-card-title>
    <mat-card-subtitle
      >Xρήστες με χρεώσιμες αποστολές και χωρίς
      αντικαταβολές.</mat-card-subtitle
    >
    <button
      mat-mini-fab
      class="refs-btn"
      color="primary"
      (click)="fetchData()"
      aria-label="Example icon button with a plus one icon">
      <i class="fas fa-redo"></i>
    </button>
  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    <div class="ucontent">
      <div *ngIf="loading" class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <div *ngIf="err" class="err">
        <div class="err-icon">
          <i class="fas fa-exclamation-triangle"></i>
        </div>
        <div class="err-msg">
          <p>
            Συνέβη ένα σφάλμα κατά την άντληση των δεδομένων. Παρακαλώ
            περιμένετε μερικά δευτερόλεπτα και ξαναπροσπαθήστε.
          </p>
        </div>
      </div>
      <perfect-scrollbar
        *ngIf="!loading && !err"
        class="scroller"
        [config]="{ suppressScrollX: true }">
        <table mat-table [dataSource]="udata">
          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef>Χρήστης</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.user.is_company">
                <a
                  class="ulink"
                  href="javascript:;"
                  (click)="viewUser(element.user)"
                  >{{ element.user.companyName }}</a
                >
              </ng-container>
              <ng-container *ngIf="!element.user.is_company">
                <a
                  class="ulink"
                  href="javascript:;"
                  (click)="viewUser(element.user)"
                  >{{ element.user.lastname }} {{ element.user.firstname }}</a
                >
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="kap">
            <th mat-header-cell *matHeaderCellDef>Κωδ. Πελάτη</th>
            <td mat-cell *matCellDef="let element">{{ element.kap }}</td>
          </ng-container>
          <ng-container matColumnDef="PROCESSED">
            <th mat-header-cell *matHeaderCellDef>Εγκρίθηκε</th>
            <td mat-cell *matCellDef="let element">
              <span class="bdg procs">{{ element.PROCESSED }} </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="RETURNED">
            <th mat-header-cell *matHeaderCellDef>Επεστράφη</th>
            <td mat-cell *matCellDef="let element">
              <span class="bdg rets">{{ element.RETURNED }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="PAID">
            <th mat-header-cell *matHeaderCellDef>Εισπράχηκε</th>
            <td mat-cell *matCellDef="let element">
              <span class="bdg paids">{{ element.PAID }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="PAID_APPROVED">
            <th mat-header-cell *matHeaderCellDef>Προς Αποδ.</th>
            <td mat-cell *matCellDef="let element">
              <span class="bdg paprs">{{ element.PAID_APPROVED }}</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </perfect-scrollbar>
    </div>
  </mat-card-content>
</mat-card>
